{
  "features": {
    "config": {
      "title": "聖羊的同伴",
      "subtitle": "Twitch 整合設定",
      "sections": {
        "premiumSkins": {
          "title": "特級外觀",
          "description": "使用此實況互動元件後，你的觀眾就能成為遊戲裡的教徒。觀眾可以自訂自己的教徒，包含使用小奇點（Bits）換取特級外觀。你可以決定換取特級外觀所需要的小奇點數量，或維持免費，讓所有人使用這些外觀。",
          "noBitsOption": "特級外觀不需要小奇點",
          "bitsFeatureNotAvailable": "你的頻道無法使用小奇點，觀眾將能任選喜歡的外觀，不必使用小奇點。"
        }
      },
      "actions": {
        "save": "儲存變更"
      }
    },
    "followers": {
      "rafflePopup": {
        "title": "加入{{channelName}}的教會！",
        "subtitle": "您贏了抽獎！",
        "timeRemaining": "剩餘時間：{{time}}",
        "message": "加入本教會有許多好處：有機會長出額外的惡魔附肢，享有把活著的每分每秒都獻給聖羊教的榮譽，還有可能被獻祭的榮耀！",
        "viewerLinkCta": "參加前，請{share your identity}。",
        "actions": {
          "joinRaffle": "我想入教",
          "joinRaffleViewerHasAlreadyJoined": "您參加了抽獎",
          "dismissRaffle": "謝謝，不用",
          "dismissRaffleViewerHasAlreadyJoined": "關閉"
        },
        "raffleJoinedMessage": "感謝您願意加入。如果您獲選入教，將馬上收到通知。您可以關閉此視窗了。"
      },
      "followerBuilder": {
        "title": "建立您的教徒",
        "steps": {
          "intro": {
            "message": "您加入本教會了！您建立的教徒將在遊戲裡出現。請別忘了，您的教徒最終會死亡，不過至少是為了崇高大業。",
            "actions": {
              "goToNextStep": "建立您的教徒"
            }
          },
          "skinSelection": {
            "actions": {
              "goToNextStep": "繼續"
            }
          },
          "colorSelection": {
            "actions": {
              "goToPreviousStep": "回到外觀",
              "goToNextStep": {
                "variationsForSkin": "繼續",
                "noVariationsForSkin": "建立教徒"
              }
            }
          },
          "variationSelection": {
            "actions": {
              "goToPreviousStep": "返回顏色",
              "goToNextStep": "建立教徒"
            }
          }
        }
      }
    },
    "helpOrHinder": {
      "help": "幫忙",
      "hinder": "阻礙",
      "hhVotingFlyout": {
        "title": "幫忙還是阻礙",
        "message": "參加投票",
        "timeRemaining": "剩餘時間：{{time}}",
        "voteCount": "{{amount}} 票"
      },
      "outcomeVotingFlyout": {
        "title": "投票參加{{channelName}}的{{helpOrHinder}}",
        "timeRemaining": "剩餘時間：{{time}}"
      }
    }
  }
}
